import React from 'react';
import styles from './Header.module.css';
import logo from '../assets/tsunami_logo_wave_crop.png';

// Header
const Header = () => {
  return (
    <header className={styles.header}>
      <div className={styles.headerContent}>
        <div className={styles.logoSection}>
          <img src={logo} alt="Tsunami FI Logo" className={styles.logoImg} />
          <span className={styles.brandName}>Tsunami FI</span>
        </div>
        <nav className={styles.nav}>
        </nav>
      </div>
    </header>
  );
};

export default Header;